import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 24px auto;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding 16px 0;

  & > p {
    font-weight: 500;
    font-size: 15px;
    line-height: 16px;
  }
`;

export const Body = styled.main`
  padding: 0 16px;
  border-radius: 5px;
  background: #FFFFFF;
  box-shadow: 0px 4px 8px 0px #00000040;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 40px 200px auto 34px;
  border-bottom: 1px solid #E0E0E0;
`;

export const TableCell = styled.div`
  padding: 20px 5px;
  color: #212121;
  line-height: 24px;
`;

export const HeaderCell = styled(TableCell)`
  color: #767676;
`;
